import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../store";
import * as LoginActions from "../../../store/loginService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as services from "../../../store/service";
interface IProps {
    packageIndex: number;
    isTwoStepCancellation: boolean;
}

const ProtectionPlanTrialCancellationConfirmationComplete: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t: tLang } = useTranslation();

    const [loading, setLoading] = useState(false);

    const sendTwoStepCancellationEvent = () => {
        services.TwoStepCancellationEvent();
    };
    const sendGeneralCancellationEvent = () => {
        services.GeneralCancellationEvent();
    };

    const displayTrialCancelCompleteMessage = () => {
        return (
            <React.Fragment>
                <p>{tLang("manageAccount.protectionPlan.trialCancellationComplete.Text1")}</p>
                <p>{tLang("manageAccount.protectionPlan.trialCancellationComplete.Text2")}</p>
            </React.Fragment>
        );
    };

    const sendSMGEvent = () => {
        if (props.isTwoStepCancellation === true) {
            sendTwoStepCancellationEvent();
        } else {
            sendGeneralCancellationEvent();
        }
    };

    const redirectToHome = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerModes &&
            state.configurationState.configuration.partnerConfig.partnerModes?.indexOf("PartnerMode.LoginOption.None") > 0
        ) {
            return true;
        }
        return false;
    });

    const originalSiteUrl: any = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.originSiteUrl
        ) {
            return state.configurationState.configuration.partnerConfig.originSiteUrl;
        } else {
            return "";
        }
    });

    const requestLogout = (event: any) => {
        setLoading(true);
        event.preventDefault();
        if (redirectToHome) {
            dispatch(LoginActions.actionCreators.logout(history, originalSiteUrl));
        } else {
            dispatch(LoginActions.actionCreators.logout(history));
        }
        dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(""));
    };

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                requestLogout(evt);
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    return (
        <React.Fragment>
            <div className={loading ? "loading" : ""}>
                <div className="dialog-header">
                    <div className="dialog-icon">
                        <RenderIcons iconName="cube" />
                    </div>
                    <h1>{tLang("manageAccount.protectionPlan.trialCancellationComplete.Title")}</h1>
                </div>

                <div className="dialog-body">{displayTrialCancelCompleteMessage()}</div>

                <div className="dialog-footer">
                    <div className={"row between-xs"}>
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="button"
                                className="btn-default btn-primary"
                                id="btn-submit-trial-cancel-complete"
                                onClick={(e) => {
                                    sendSMGEvent();
                                    requestLogout(e);
                                    window.addToDataLayer({ event: "Protection Plan - Cancel My Trial Complete - Logout" });
                                }}
                            >
                                <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.logout")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default ProtectionPlanTrialCancellationConfirmationComplete;
